import React, { useState } from "react";
import Dashboard from "./Dashboard";
import StoresPanel from "./StoresPanel";
import FileManager from "./FileManager";
import UpdatePanel from "./UpdatePanel";
import PricingPanel from "./PricingPanel";
import PembayaranPanel from "./PembayaranPanel";
import ReferalDaftar from "./ReferalDaftar";
import Penarikan from "./Penarikan";
import Broadcast from "./Broadcast";
import LiveChat from "./LiveChat";
import SecurityPanel from "./SecurityPanel";
import SettingsPanel from "./SettingsPanel";
import Sidebar from "./layout/Sidebar";
import Topbar from "./layout/Topbar";
import useAdminNotifications from "../hooks/useAdminNotifications";

/**
 * Application shell.
 *
 * Owns only navigation chrome (active tab, sidebar state). Every page keeps
 * its own data logic; this component just mounts the selected page — exactly
 * like before, just with a modern sidebar + topbar around it.
 */
export default function AdminPanel({ user, onLogout }) {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { notifications, badges } = useAdminNotifications();

  const handleNavigate = (id) => {
    setActiveTab(id);
    setMobileOpen(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
      <Sidebar
        activeTab={activeTab}
        onSelect={handleNavigate}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((v) => !v)}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
        onLogout={onLogout}
        badges={badges}
      />

      <div
        className={`flex min-h-screen flex-col transition-[padding] duration-250 ${collapsed ? "lg:pl-[78px]" : "lg:pl-64"}`}
        style={{ "--sidebar-w": collapsed ? "78px" : "16rem" }}
      >
        <Topbar
          activeTab={activeTab}
          onNavigate={handleNavigate}
          onOpenSidebar={() => setMobileOpen(true)}
          user={user}
          onLogout={onLogout}
          notifications={notifications}
        />

        <main className="flex-1 px-4 py-5 sm:px-6 sm:py-6">
          <div className="mx-auto w-full max-w-[1440px]">
            {activeTab === "dashboard" && <Dashboard />}
            {activeTab === "toko" && <StoresPanel />}
            {activeTab === "files" && <FileManager />}
            {activeTab === "update" && <UpdatePanel />}
            {activeTab === "pricing" && <PricingPanel />}
            {activeTab === "pembayaran" && <PembayaranPanel />}
            {activeTab === "referal" && <ReferalDaftar />}
            {activeTab === "penarikan" && <Penarikan />}
            {activeTab === "broadcast" && <Broadcast />}
            {activeTab === "livechat" && <LiveChat />}
            {activeTab === "security" && <SecurityPanel />}
            {activeTab === "settings" && <SettingsPanel />}
          </div>
        </main>
      </div>
    </div>
  );
}
